import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import PropTypes from 'prop-types';
import './TrendOverlay.scss';

const TrendOverlay = ({debtAmountData, paymentData}) => {
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);

//   const data = [
//     { id: 1, name: 'test', value: '50' },
//     { id: 2, name: 'pass', value: '20' },
//     { id: 3, name: 'fail', value: '30' },
//   ];

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const ctx = chartRef.current.getContext('2d');
      // console.log(paymentData);
      // console.log(debtAmountData);

      const labels = paymentData.map((item) => item.name);
      const values = paymentData.map((item) => item.value);
      const colors = [
        'rgba(133, 113, 244, 1)',
        'rgba(133, 113, 244, 0.6)',
        'rgba(69, 208, 238, 0.6)',
        'rgba(69, 208, 238, 1)',
        'rgba(178, 124, 240, 1)',
        'rgba(133, 113, 244, 1)',
        'rgba(9, 114, 121, 1)',
        'rgba(48, 206, 216, 1)'
      ];

      const myChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [
            {
              data: values,
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  return context.label + ': ' + context.formattedValue;
                },
              },
            },
            legend: {
              display: false,
            },
          },
        },
      });

      const legend = document.getElementById('legend');

      if (legend) {
        labels.forEach((label, index) => {
          const li = document.createElement('li');
          li.textContent = `${label} `; // Display label with percentage
          li.classList.add('amount-modal'); // Add your class name here
          li.style.color = colors[index % colors.length]; // Set text color to white
          li.style.listStyleType = 'none'; // Remove default bullet style
          legend.appendChild(li);

          // Create a span element for the bullet
          const bullet = document.createElement('span');
          bullet.textContent = ''; // No text content needed
          bullet.classList.add('bullet'); // Add a class for styling
          bullet.style.borderColor = colors[index % colors.length]; // Set border color
          li.insertBefore(bullet, li.firstChild); // Insert the bullet before the text content
        });
      }

      return () => {
        myChart.destroy();
      };
    }
  }, []);

  useEffect(() => {
    if (chartRef2 && chartRef2.current) {
      const ctx2 = chartRef2.current.getContext('2d');

      const labels2 = debtAmountData.map((item) => item.name);
      const values2 = debtAmountData.map((item) => item.value);

      const colors2 = [
        'rgba(133, 113, 244, 1)',
        'rgba(133, 113, 244, 0.6)',
        'rgba(69, 208, 238, 0.6)',
        'rgba(69, 208, 238, 1)',
        'rgba(131, 60, 202, 1)',
        'rgba(30, 156, 164, 1)',
      ];

      const myChart2 = new Chart(ctx2, {
        type: 'pie',
        data: {
          labels: labels2,
          datasets: [
            {
              data: values2,
              backgroundColor: colors2,
              borderColor: colors2,
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  return context.label + ': ' + context.formattedValue;
                },
              },
            },
            legend: {
              display: false,
            },
          },
        },
      });

      return () => {
        myChart2.destroy();
      };
    }
  }, []);

  return (
    <>
      <div className="card" id="overlay">
        <div className="card-header" id="amount-modal-header">
          <p>Debts</p>
        </div>
        <div className="card-body">
          <div className='card-body__trendoverlay-collected'>
            <canvas width="200" ref={chartRef}></canvas>
            <p className='paid_overlay'>Debts collected</p>
          </div>
          <ul id="legend"></ul>
          <div className='card-body__trendoverlay-pending'>
            <canvas width="200" ref={chartRef2}></canvas>
            <p className='debt_overlay'>Debts pending</p>
          </div>
        </div>
      </div>
    </>
  );
};

TrendOverlay.propTypes = {
  number: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  debtAmountData: PropTypes.array.isRequired,
  paymentData: PropTypes.array.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default TrendOverlay;
